import { Help } from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";
import styles from "./Fieldset.module.scss";

function Fieldset({
  children,
  tooltip,
  legend,
}: {
  legend: string;
  tooltip?: string;
  children: React.ReactNode;
}) {
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        <span>{legend}</span>
        {tooltip && (
          <Tooltip content={tooltip} asChild={false}>
            <Help className={styles.icon} />
          </Tooltip>
        )}
      </legend>
      {children}
    </fieldset>
  );
}

export default Fieldset;
